// @react-compiler enable
import {testIdProps} from '@github-ui/test-id-props'
import {memo} from 'react'

import type {DateValue} from '../../../api/columns/contracts/date'
import {formatDateString} from '../../../helpers/parsing'
import {type ColumnValue, isEmpty, isLoading} from '../../../models/column-value'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {TextPlaceholder} from '../../common/placeholders'
import {BaseCell} from '../cells/base-cell'
import {TextCell} from '../cells/text-cell'
import {useRecordCellRenderer} from '../performance-measurements'
import styles from './date-renderer.module.css'

type Props = Readonly<{
  currentValue: ColumnValue<DateValue>
  model: MemexItemModel
  isDisabled?: boolean
  tooltipText?: string
  localTimezone?: boolean
}>

export const LoadingDateCell = () => (
  <BaseCell>
    <TextPlaceholder minWidth={80} maxWidth={100} {...testIdProps('placeholder')} />
  </BaseCell>
)

export const DateRenderer = memo(function DateRenderer({
  currentValue,
  model,
  isDisabled,
  tooltipText,
  localTimezone,
}: Props) {
  useRecordCellRenderer('DateRenderer', model.id)

  if (isLoading(currentValue)) {
    return <LoadingDateCell />
  }

  if (isEmpty(currentValue)) {
    return null
  }

  const dateString = formatDateString(currentValue.value.value, {localTimezone})

  return (
    <BaseCell className={styles.BaseCell} title={tooltipText}>
      <TextCell dangerousHtml={dateString} isDisabled={isDisabled} />
    </BaseCell>
  )
})
